import { ChevronRight, ChevronLeft, CheckCircle2, Circle } from '@/components/icons';
import { useOnboarding } from '../../context/OnboardingContext';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './dialog';

const steps = [
  {
    title: 'Create Node',
    description: 'Add your first node to the canvas. ',
    tip: 'Press Ctrl+K or Cmd+K to open the command palette',
    gif: '/onboarding-step1.gif',
  },
  {
    title: 'Connect Nodes',
    description: 'Link your nodes together. ',
    tip: 'Drag from a node handle to another node to connect',
    gif: '/onboarding-step2.gif',
  },
  {
    title: 'Export Diagram',
    description: 'Share your creation. ',
    tip: 'Export your diagram as PNG or SVG to share it',
    gif: '/onboarding-step3.gif',
  },
];

export default function OnboardingModal() {
  const { currentStep, setStep, isOpen, nextStep, prevStep, skipOnboarding, completeOnboarding } = useOnboarding();

  const currentStepData = steps[currentStep];
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === steps.length - 1;

  const handleNext = () => {
    if (isLastStep) {
      completeOnboarding();
    } else {
      nextStep();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && skipOnboarding()}>
      <DialogContent className="max-w-2xl gap-0 overflow-hidden p-0">
        <div className="px-6 py-4 pr-12">
          <DialogTitle className="text-xl font-semibold text-foreground dark:text-foreground">
            {currentStepData.title}
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground dark:text-muted-foreground mt-0.5">
            {currentStepData.description} {currentStepData.tip}
          </DialogDescription>
        </div>

        <div className="p-6 pt-4">
          {/* <div className="relative w-full aspect-video bg-muted dark:bg-card rounded-xl overflow-hidden mb-6">
            <img
              src={currentStepData.gif}
              alt={`Step ${currentStep + 1}: ${currentStepData.title}`}
              className="w-full h-full object-cover"
            />
          </div> */}

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              {steps.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    if (index <= currentStep) {
                      setStep(index);
                    }
                  }}
                  className="focus:outline-none"
                  disabled={index > currentStep}
                >
                  {index < currentStep ? (
                    <CheckCircle2 className="w-5 h-5 text-green-500" />
                  ) : (
                    <Circle className={`w-5 h-5 ${index === currentStep ? 'text-primary fill-indigo-100 dark:fill-indigo-900/30' : 'text-muted-foreground dark:text-muted-foreground'}`} />
                  )}
                </button>
              ))}
            </div>

            <div className="flex items-center gap-3">
              {!isFirstStep && (
                <Button
                  variant="ghost"
                  onClick={prevStep}
                  className="text-muted-foreground dark:text-muted-foreground"
                >
                  <ChevronLeft className="w-4 h-4 mr-1" />
                  Previous
                </Button>
              )}
              <Button onClick={handleNext} className="min-w-[100px]">
                {isLastStep ? (
                  'Done'
                ) : (
                  <>
                    Next
                    <ChevronRight className="w-4 h-4 ml-1" />
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
